module.exports = __webpack_public_path__ + "img/epicycloid_info_nature.7401a400.jpg";